import { render, staticRenderFns } from "./AttendeesPage.vue?vue&type=template&id=2fb903a0&"
import script from "./AttendeesPage.vue?vue&type=script&lang=js&"
export * from "./AttendeesPage.vue?vue&type=script&lang=js&"
import style0 from "./AttendeesPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VSkeletonLoader})
